import { render, staticRenderFns } from "./CopyOrMoveContentToCollectionModal.vue?vue&type=template&id=69b585a0&lang=pug&"
import script from "./CopyOrMoveContentToCollectionModal.vue?vue&type=script&lang=js&"
export * from "./CopyOrMoveContentToCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports